module.exports = new __parcel__URL__("icybindings.a5e7e536.png").toString();